/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/control-has-associated-label */
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import { Checkbox } from '@mui/material';
import { IMultiplePaymentSolicitationInputModel } from 'inputModels';
import { serialize } from 'object-to-formdata';
import { useState } from 'react';
import Modal from 'react-modal';
import { ReactComponent as IconDollar } from '../../../assets/icons/iconDollar.svg';
import { ReactComponent as IconPaperClip } from '../../../assets/icons/IconPaperclip.svg';
import { SolicitationController } from '../../../controller/SolicitationController';
import { PaymentSolicitationStatus } from '../../../types/enums';
import { Attachment } from '../../Attachment';
import { Button } from '../../Buttons/Button';
import { ContentModal, Header } from './styles';
import { CustomFile, DropZone } from '../../DropZone';
import { useAlert } from '../../../hooks/useAlert';
import { useSolicitation } from '../../../context/solicitation';
import { usePayment } from '../../../context/payment';

interface StatusPaymentProps {
  isOpen: boolean;
  onRequestClose: () => void;
  solicitationsIds?: string[];
}
export function ModalPaymentMultiple({
  isOpen,
  solicitationsIds,
  onRequestClose,
}: StatusPaymentProps) {
  const alert = useAlert();
  const { setPayments } = usePayment();
  const { setSolicitations } = useSolicitation();
  const [attachment, setAttachment] = useState<CustomFile>();
  const [showError, setShowError] = useState(false);
  const [statusPayment, setStatusPayment] = useState(false);

  const handleUpdateStatus = async () => {
    const update: IMultiplePaymentSolicitationInputModel = {
      solicitationsIds: solicitationsIds ?? [],
      paymentSolicitationStatus:
        statusPayment === true ? PaymentSolicitationStatus.PAID : PaymentSolicitationStatus.UNPAID,
    };
    const formData = serialize(update, { indices: true });
    if (attachment?.file) formData.append('paymentDocument', attachment.file);

    SolicitationController.updateMultiplePaymentStatus(formData)
      .then(() => {
        if (!solicitationsIds) return;
        setSolicitations((prev) => {
          const newSolicitations = [...prev];
          solicitationsIds.forEach((id) => {
            const solicitationIdx = newSolicitations.findIndex((s) => s.paymentId === id);
            if (solicitationIdx !== -1) {
              newSolicitations[solicitationIdx].payment.paymentSolicitationStatus =
                update.paymentSolicitationStatus;
              if (attachment?.file) {
                newSolicitations[solicitationIdx].payment.paymentDocument = attachment.file;
              }
            }
          });
          setPayments((prevPayments) => {
            const newPayments = [...prevPayments];
            solicitationsIds.forEach((id) => {
              const paymentIdx = newPayments.findIndex((p) => p.solicitationId === id);
              if (paymentIdx !== -1) {
                newPayments[paymentIdx].paymentStatus = update.paymentSolicitationStatus;
                newPayments[paymentIdx].paymentDocument = attachment?.file;
              }
            });
            return newPayments;
          });
          return newSolicitations;
        });
        alert.show({ message: 'Documento anexado com sucesso!', type: 'success' });
        onRequestClose();
      })
      .catch(() => alert.show({ message: 'Erro ao anexar documento!', type: 'error' }));
  };

  const handleRequestClose = () => {
    onRequestClose();
    setShowError(false);
  };

  const handleUpdateStatusCheckbox = (status: boolean) => {
    if (!attachment && status) setShowError(true);
    else setStatusPayment(status);
  };
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-status-payment-modal-content">
      <Header>
        <div>
          <h1>
            <IconDollar /> Status do pagamento
          </h1>
        </div>
        <div className="close-div">
          <button type="button" onClick={handleRequestClose}>
            <CloseIcon fontSize="small" />
          </button>
        </div>
      </Header>
      <ContentModal>
        <div className="container">
          <div className="containerStatus">
            <div className="contentStatus">
              <Checkbox
                checked={statusPayment}
                id="paid-out"
                onChange={() => handleUpdateStatusCheckbox(true)}
                disabled={statusPayment}
              />
              <label htmlFor="paid-out" className={statusPayment ? 'labelDisabled' : ''}>
                Pago
              </label>
            </div>
            <div className="contentStatus">
              <Checkbox
                checked={!statusPayment}
                id="unpaid"
                onChange={() => handleUpdateStatusCheckbox(false)}
                disabled={statusPayment}
              />
              <label htmlFor="unpaid" className={statusPayment ? 'labelDisabled' : ''}>
                Não pago
              </label>
            </div>
          </div>
        </div>
        <div className="containerAttachment">
          <div className="contentAttachment">
            <div>
              <h1>
                <IconPaperClip />
                {statusPayment ? 'Comprovante' : 'Anexar Comprovante'}
              </h1>
            </div>
            {!attachment ? (
              <div className="contentDropzone">
                <DropZone
                  multipleFiles={false}
                  type="attachments"
                  onFile={(file) => {
                    setAttachment(file);
                    setStatusPayment(true);
                  }}
                />
              </div>
            ) : (
              <div className="contentDropzone">
                <Attachment
                  data={{
                    id: attachment.id,
                    type: attachment.file?.type ?? '',
                    name: attachment.file?.name ?? 'Sem nome',
                    uri: attachment.preview ?? undefined,
                  }}
                  onDelete={() => {
                    setAttachment(undefined);
                    setStatusPayment(false);
                  }}
                />
              </div>
            )}
          </div>
          {showError && (
            <p className="error">
              <ErrorIcon />
              Anexe o comprovante para atualizar o status de pagamento
            </p>
          )}
        </div>
        <div className="content-buttons">
          <Button
            text="Cancelar"
            dimensions={{ width: '12rem', height: '2rem' }}
            font={{ size: '14' }}
            color="background_white"
            background="primary"
            backgroundHoverColor="tertiary_500"
            textHoverColor="background_white"
            onClick={handleRequestClose}
          />

          <Button
            text="Confirmar"
            dimensions={{ width: '12rem', height: '2rem' }}
            font={{ size: '14' }}
            color="background_white"
            background="secondary"
            backgroundHoverColor="tertiary_500"
            textHoverColor="background_white"
            border={{ color: 'primary' }}
            onClick={handleUpdateStatus}
          />
        </div>
      </ContentModal>
    </Modal>
  );
}
